// extracted by mini-css-extract-plugin
export default {"wrapper":"strings-list-control_wrapper__0h1po","wrapperError":"strings-list-control_wrapperError__jo7wc"};